import { createGlobalStyle } from 'styled-components';
import { colorVarNames, fontVarNames } from 'voyager';

export const VoyagerThemeBridge = createGlobalStyle`
  :root {
    ${colorVarNames.primary}: ${({ theme }) => theme.customColors.primary};
    ${colorVarNames.tertiary}: ${({ theme }) => theme.customColors.tertiary};
    ${colorVarNames.navigationAndFooter}: ${({ theme }) => theme.customColors.navigationAndFooter};
    ${colorVarNames.header}: ${({ theme }) => theme.customColors.header};
    ${colorVarNames.sectionTitle}: ${({ theme }) => theme.customColors.sectionTitle};

    ${colorVarNames.black}: ${({ theme }) => theme.defaultColors.black};
    ${colorVarNames.white}: ${({ theme }) => theme.defaultColors.white};
    ${colorVarNames.offWhite}: ${({ theme }) => theme.defaultColors.offWhite};

    ${fontVarNames.heading}: ${({ theme }) => theme.headerFont}, serif;
    ${fontVarNames.body}: ${({ theme }) => theme.bodyFont}, sans-serif;
  }
`;
